export const SET_DATA_LOADED = 'SET_DATA_LOADED'

export function setDataLoaded (dataLoaded) {
  return {
    type: SET_DATA_LOADED,
    data: dataLoaded,
  }
}
